import $http from '../../utils/http';

// # 留言管理
// ##### 咨询对象 下拉框
const getAdvisoryObjectList = params => {
    return $http({
        url: '/investment/sys/pr-message-board/advisoryObjectList',
        params
    });
};

// ##### #留言版列表
const getInvestmentMessageList = params => {
    return $http({
        url: '/investment/sys/pr-message-board/list',
        params
    });
};

// ##### #留言明细
const getInvestmentMessageDetails = params => {
    return $http({
        url: '/investment/sys/pr-message-board/details',
        params
    });
};

// ##### #留言明细
const getInvestmentMessageDealList = params => {
    return $http({
        url: '/investment/sys/pr-message-deal-record/list',
        params
    });
};

// ##### #留言处理
const addPrMessageFealRecord = params => {
    return $http({
        url: '/investment/sys/pr-message-deal-record/add',
        data: params,
        method: 'POST'
    });
};

// ##### #投资方管理
const getInvestorInfo = params => {
    return $http({
        url: '/investment/investorInfoManage/pr-investor-info/getInvestorInfo',
        params
    });
};

// ##### #投资方管理
const getInvestorList = params => {
    return $http({
        url: '/investment/investorInfoManage/pr-investor-info/getInvestorList',
        params
    });
};

// ##### #删除投资方
const delInvestor = params => {
    return $http({
        url: '/investment/investorInfoManage/pr-investor-info/delInvestor',
        params,
        method: 'POST'
    });
};
// ##### #招商活动 列表接口
const getInvestList = params => {
    return $http({
        url: '/investment/investmentManage/pr-investment-manage/investList',
        params,
        method: 'POST'

    });
};

// ##### #招商活动 详情接口
const getInvestLoadBy = params => {
    return $http({
        url: '/investment/investmentManage/pr-investment-manage/loadBy/' + params.id,
        params
    });
};

// ##### #招商活动 删除接口
const removeInvest = params => {
    return $http({
        url: '/investment/investmentManage/pr-investment-manage/removeInvest/' + params.id,
        params
    });
};

// ##### #信息发布 列表接口
const getAttractList = params => {
    return $http({
        url: '/investment/sys/attract/list',
        params
    });
};
// ##### #信息发布 列表接口
const getBusinessList = params => {
    return $http({
        url: '/investment/sys/business/list',
        params
    });
};
// ##### #信息发布 列表接口
const getContactUsList = params => {
    return $http({
        url: '/investment/sys/contactUs/list',
        params
    });
};
// ##### #信息发布 列表接口
const getCompanyPartnerList = params => {
    return $http({
        url: '/investment/sys/companyPartner/list',
        params
    });
};
// ##### #信息发布 列表接口
const getFindOperatingConfigList = params => {
    return $http({
        url: '/investment/sys/operating/findOperatingConfigList',
        params
    });
};
// ##### #信息发布 单条查询
const getAttractDetails = params => {
    return $http({
        url: '/investment/sys/attract/saveDetails',
        params
    });
};
// ##### #信息发布 单条查询
const getBusinessDetails = params => {
    return $http({
        url: '/investment/sys/business/details',
        params
    });
};
// ##### #信息发布 单条查询
const getContactUsDetails = params => {
    return $http({
        url: '/investment/sys/contactUs/details',
        params
    });
};
// ##### #信息发布 单条查询
const getCompanyPartnerDetails = params => {
    return $http({
        url: '/investment/sys/companyPartner/details',
        params
    });
};
// ##### #信息发布 单条查询
const getOperatingDetail = params => {
    return $http({
        url: '/investment/sys/operating/queryById',
        params
    });
};

// ##### #信息发布 地点接口
const getAllProjectType = params => {
    return $http({
        url: '/investment/sys/pe-type/getAllProjectType',
        params
    });
};
// ##### #信息发布 地点接口
const getAllLocation = params => {
    return $http({
        url: '/investment/sys/regionalism/getAllLocation',
        params
    });
};

// ##### #信息发布 删除
const deleteAttract = params => {
    return $http({
        url: '/investment/sys/attract/delete',
        params,
        method: 'POST'
    });
};

// ##### #信息发布 删除
const deleteContactUs = params => {
    return $http({
        url: '/investment/sys/contactUs/delete',
        params,
        method: 'POST'
    });
};

// ##### #信息发布 删除
const deleteCompanyPartner = params => {
    return $http({
        url: '/investment/sys/companyPartner/delete',
        params,
        method: 'POST'
    });
};

// ##### #信息发布 停用或启用
const updateAttract = params => {
    return $http({
        url: '/investment/sys/investment/using',
        data: params,
        method: 'POST',
        isMultipart: 'application/x-www-form-urlencoded'
    });
};
// ##### #信息发布 停用或启用
const updateBusinessUsing = params => {
    return $http({
        url: '/investment/sys/business/using',
        data: params,
        method: 'POST',
        isMultipart: 'application/x-www-form-urlencoded'
    });
};
// ##### #信息发布 停用或启用
const updateEnable = params => {
    return $http({
        url: '/investment/sys/operating/enable',
        data: params,
        method: 'POST'
    });
};
// ##### #信息发布 停用或启用
const updateDisable = params => {
    return $http({
        url: '/investment/sys/operating/disable',
        data: params,
        method: 'POST'
    });
};

// ##### #信息发布 审核接口
const verifyAttract = params => {
    return $http({
        url: '/investment/sys/investment/verify',
        data: params,
        method: 'POST'
    });
};

// ##### #信息发布 审核接口
const verifyBusiness = params => {
    return $http({
        url: '/investment/sys/business/verify',
        data: params,
        method: 'POST'
    });
};

// ##### #信息发布 审核接口
const verifyContact = params => {
    return $http({
        url: '/investment/sys/contactUs/audit',
        data: params,
        method: 'POST'
    });
};

// ##### #信息发布 审核接口
const verifyCompanyPartner = params => {
    return $http({
        url: '/investment/sys/companyPartner/audit',
        data: params,
        method: 'POST'
    });
};

// ##### #信息发布 审核接口
const verifyAgree = params => {
    return $http({
        url: '/investment/sys/operating/verifyAgree',
        data: params,
        method: 'POST'
    });
};

// ##### #信息发布 审核接口
const verifyDisagree = params => {
    return $http({
        url: '/investment/sys/operating/verifyDisagree',
        data: params,
        method: 'POST'
    });
};

// ##### #项目管理 项目进度
const getProgressAll = params => {
    return $http({
        url: '/investment/sys/attract/progress/all',
        params

    });
};

// ##### #项目管理 项目列表
const getProjectList = params => {
    return $http({
        url: '/investment/sys/attract/project/list',
        params
    });
};

// ##### #项目管理 项目详情
const getProjectDetail = params => {
    return $http({
        // url: '/investment/sys/attract/project/detail',
        url: '/investment/sys/attract/project/detailWithEdit',
        params

    });
};
// ##### #项目管理 项目详情
const getProjectDetailAttract = params => {
    return $http({
        url: '/investment/sys/attract-edit/detail/attract_id',
        params

    });
};

// ##### #项目管理 投资方跟踪
const getProjectInvestorTracking = params => {
    return $http({
        url: '/investment/sys/project-investor-tracking/attract_id',
        params

    });
};

// ##### #项目管理 项目跟踪
const getAttractInvestmentId = params => {
    return $http({
        url: '/investment/sys/project-tracking-record/list/attractInvestmentId',
        params

    });
};

// ##### #首页 留言待处理
const getTotalUndone = params => {
    return $http({
        url: '/investment/sys/pr-message-board/totalUndone',
        params

    });
};

// ##### #首页 信息发布待审核
const getPublicUnDone = params => {
    return $http({
        url: '/investment/sys/business/publicUnDone',
        params

    });
};

// ##### #首页 项目待审核
const getVerifying = params => {
    return $http({
        url: '/investment/sys/attract/count/status/verifying',
        params

    });
};

// ##### #首页 首页留言统计
const getTotalMessage = params => {
    return $http({
        url: '/investment/sys/pr-message-board/totalMessage',
        params

    });
};

// ##### #首页 首页信息发布统计
const getPublicTotal = params => {
    return $http({
        url: '/investment/sys/business/publicTotal',
        params

    });
};

// ##### #首页 首页项目统计
const getProgressNum = params => {
    return $http({
        url: '/investment/sys/attract/count/progress/num',
        params

    });
};

// ##### #首页 首页投资方统计
const getInvestorNum = params => {
    return $http({
        url: '/investment/index/investor',
        method: 'POST',
        params

    });
};

// ##### #首页 首页招商活动统计
const getPrInvestmentManage = params => {
    return $http({
        url: '/investment/investmentManage/pr-investment-manage/total',
        params

    });
};

// ##### #项目管理 删除项目详情
const deleteAttractById = params => {
    return $http({
        url: '/investment/sys/attract/deleteAttractById',
        data: params,
        method: 'POST'

    });
};

// ##### #项目管理 审核项目详情
const postAttractVerify = params => {
    return $http({
        url: '/investment/sys/attract/verify',
        data: params,
        method: 'POST'

    });
};

// ##### #投资方 洽谈记录
const getDockingNegotiateList = params => {
    return $http({
        url: '/investment/investorInfoManage/pr-docking-negotiate/getDockingNegotiateList',
        params

    });
};

// ##### #投资方 洽谈详情
const getDockingNegotiate = params => {
    return $http({
        url: '/investment/investorInfoManage/pr-docking-negotiate/getDockingNegotiate',
        params

    });
};

// ##### #投资方 投资项目
const getInvestorProjectList = params => {
    return $http({
        url: '/investment/investorInfoManage/pr-investor-info/getInvestorProjectList',
        params

    });
};

// ##### #招商活动管理 单位
const orgUnitList = params => {
    return $http({
        url: '/investment/sys/business/orgUnitList',
        params

    });
};

export default {
    getAdvisoryObjectList,
    getInvestmentMessageList,
    getInvestmentMessageDetails,
    getInvestorInfo,
    getInvestList,
    getInvestLoadBy,
    removeInvest,
    getAttractList,
    getAllProjectType,
    getBusinessList,
    getContactUsList,
    getCompanyPartnerList,
    getFindOperatingConfigList,
    getAttractDetails,
    getBusinessDetails,
    getContactUsDetails,
    getCompanyPartnerDetails,
    getOperatingDetail,
    deleteAttract,
    deleteContactUs,
    deleteCompanyPartner,
    updateAttract,
    updateEnable,
    updateDisable,
    verifyAttract,
    verifyContact,
    verifyCompanyPartner,
    verifyAgree,
    delInvestor,
    verifyDisagree,
    verifyBusiness,
    addPrMessageFealRecord,
    getInvestmentMessageDealList,
    getProgressAll,
    getProjectList,
    getProjectDetail,
    getProjectDetailAttract,
    getProjectInvestorTracking,
    getAttractInvestmentId,
    getTotalUndone,
    getPublicUnDone,
    getVerifying,
    getTotalMessage,
    getPublicTotal,
    getProgressNum,
    getInvestorNum,
    getPrInvestmentManage,
    deleteAttractById,
    postAttractVerify,
    getInvestorList,
    getDockingNegotiateList,
    getDockingNegotiate,
    getInvestorProjectList,
    orgUnitList,
    getAllLocation,
    updateBusinessUsing
};
